<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/Page-header";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "用戶使用紀錄",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "用戶使用紀錄",
          active: true,
        }
      ],
      pluginItem: {
        title: '',
        des: ''
      },
      currentPage: 1,
      totalRows: 1,
      perPgae: 15,
      searchEmail: "",
      memberRecords: []
    };
  },
  components: {
    Layout,
    PageHeader,
  },
  created () {
    this.getMemberRecordList()
  },
  watch: {
    currentPage (_page) {
      this.getMemberRecordList()
    }
  },
  methods: {
    getMemberRecordList () {
      let search = { email: this.searchEmail, page: this.currentPage }
      this.$root.apis.getMemberRecordList(search, this.processSearchMemberRecordList)
    },
    processSearchMemberRecordList (_response) {
      this.memberRecords = _response.body.items
      // 處理分頁相關
      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPgae = _response.body.per_page
    },
    createTopic () {

    },
    editorTopic () {

    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-xl-12">
        <!-- Simple card -->
        <b-card>
          <div class="row">
            <div class="col-9">
              <div class="form-group">
                <label for="field-2" class="control-label">Email</label>
                <input class="form-control" placeholder="請輸入用戶 Emaii" v-model="searchEmail" />
              </div>

            </div>
            <div class="col-3 text-right pt-3">
              <b-button variant="primary" type="button" @click="getMemberRecordList">查詢</b-button>
            </div>
          </div>

        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>項次</th>
                    <th>用戶Email</th>
                    <th>用戶名稱</th>
                    <th>用戶分鐘方案</th>
                    <th>當月總錄音時間</th>
                    <th>總錄音時間</th>
                    <th>總平均分數</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody v-if="!memberRecords.length">
                  <tr>
                    <td colspan="9" class="text-center">無資料</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(record, index) in memberRecords">
                    <td class="text-center">{{ (index + 1) }}</td>
                    <td class="text-left">{{ record.email }}</td>
                    <td class="text-center">{{ record.name }}</td>
                    <td class="text-center">{{ record.planMin }}分鐘</td>
                    <td class="text-center">{{ $root.common.getTimeHourAndMin(record.secondByTotal) }}</td>
                    <td class="text-center">{{ $root.common.getTimeHourAndMin(record.secondByMonth) }}</td>
                    <td class="text-center">{{ record.scoreByTotal }} / 100</td>
                    <td class="text-center">
                      <b-button size="sm" variant="primary"
                        @click="$router.push('/users/records/user/item/' + record.member_id)">查看</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPgae"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

  </Layout>
</template>
